import { lazy, Suspense, useEffect } from 'react';

import { useAiOrchestrator } from 'src/ai-orchestrator';
import { ErrorBoundary } from 'src/components/error-boundary/error-boundary';
import { useBoolean } from 'src/hooks/use-boolean';

// The chat UI and its markdown renderer load on first open instead of with every page.
const AiAssistantDrawer = lazy(() =>
  import('src/views/dashboard/ai-orchestrator/ai-assistant-drawer').then((module) => ({
    default: module.AiAssistantDrawer,
  }))
);

export const LazyAiAssistantDrawer = () => {
  const { isOpen } = useAiOrchestrator();
  // Stays mounted after the first open, so closing keeps its exit animation and state.
  const { value: hasOpened, onTrue: markOpened } = useBoolean();

  useEffect(() => {
    if (isOpen) markOpened();
  }, [isOpen, markOpened]);

  if (!isOpen && !hasOpened) return null;

  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <AiAssistantDrawer />
      </Suspense>
    </ErrorBoundary>
  );
};
